import { Component } from '@angular/core';

@Component({
  selector: 'app-onhold-cases-list',
  templateUrl: './onhold-cases-list.component.html',
  styleUrls: ['./onhold-cases-list.component.css']
})
export class OnholdCasesListComponent {

}
